"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Testimonial = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _theming = require("@storybook/theming");

var _designSystem = require("@storybook/design-system");

var _styles = require("./shared/styles");

var _excluded = ["inverse", "text", "avatarUrl", "name", "jobTitle", "logo", "companyName"];

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var Wrapper = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e1q85w3t8"
} : {
  target: "e1q85w3t8",
  label: "Wrapper"
})(_styles.pageMargins, ";margin:0;");
var Inner = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e1q85w3t7"
} : {
  target: "e1q85w3t7",
  label: "Inner"
})("display:flex;align-items:center;justify-content:center;flex-direction:column;padding-top:3rem;padding-bottom:3rem;@media (min-width: ", _styles.breakpoints[1], "px){padding-top:7rem;padding-bottom:7rem;}");
var Quote = (0, _theming.styled)("blockquote", process.env.NODE_ENV === "production" ? {
  target: "e1q85w3t6"
} : {
  target: "e1q85w3t6",
  label: "Quote"
})(_styles.marketing.textLarge, ";@media (min-width: ", _styles.breakpoints[1], "px){font-size:", _styles.typography.size.m1, "px;line-height:32px;}color:", function (props) {
  return props.inverse ? _styles.color.lightest : _styles.color.darkest;
}, ";margin-top:0;margin-right:0;margin-left:0;margin-bottom:2rem;max-width:590px;text-align:center;");
var Cite = (0, _theming.styled)("cite", process.env.NODE_ENV === "production" ? {
  target: "e1q85w3t5"
} : {
  target: "e1q85w3t5",
  label: "Cite"
})(process.env.NODE_ENV === "production" ? {
  name: "csv4ia",
  styles: "display:flex;align-items:stretch;font-style:normal"
} : {
  name: "csv4ia",
  styles: "display:flex;align-items:stretch;font-style:normal",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var Meta = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e1q85w3t4"
} : {
  target: "e1q85w3t4",
  label: "Meta"
})(process.env.NODE_ENV === "production" ? {
  name: "v1s1f3",
  styles: "margin-left:12px"
} : {
  name: "v1s1f3",
  styles: "margin-left:12px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var Author = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e1q85w3t3"
} : {
  target: "e1q85w3t3",
  label: "Author"
})(process.env.NODE_ENV === "production" ? {
  name: "s5xdrg",
  styles: "display:flex;align-items:center"
} : {
  name: "s5xdrg",
  styles: "display:flex;align-items:center",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var Name = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e1q85w3t2"
} : {
  target: "e1q85w3t2",
  label: "Name"
})("font-size:", _styles.typography.size.s2, "px;font-weight:", _styles.typography.weight.bold, ";color:", function (props) {
  return props.inverse ? _styles.color.lightest : _styles.color.darkest;
}, ";");
var JobTitle = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e1q85w3t1"
} : {
  target: "e1q85w3t1",
  label: "JobTitle"
})("font-size:", _styles.typography.size.s1, "px;color:", _styles.color.mediumdark, ";");
var Logo = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e1q85w3t0"
} : {
  target: "e1q85w3t0",
  label: "Logo"
})("border-left:1px solid ", function (props) {
  return props.inverse ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)';
}, ";margin-left:20px;padding-left:20px;display:flex;align-items:center;@media (min-width: ", _styles.breakpoints[1], "px){margin-left:50px;padding-left:40px;}img{display:inline-block;width:auto;max-height:30px;}");

var Testimonial = function Testimonial(_ref) {
  var inverse = _ref.inverse,
      text = _ref.text,
      avatarUrl = _ref.avatarUrl,
      name = _ref.name,
      jobTitle = _ref.jobTitle,
      logo = _ref.logo,
      companyName = _ref.companyName,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(Wrapper, props, /*#__PURE__*/_react["default"].createElement(Inner, null, /*#__PURE__*/_react["default"].createElement(Quote, {
    inverse: inverse
  }, text), /*#__PURE__*/_react["default"].createElement(Cite, null, /*#__PURE__*/_react["default"].createElement(Author, null, /*#__PURE__*/_react["default"].createElement(_designSystem.Avatar, {
    size: "large",
    username: name,
    src: avatarUrl
  }), /*#__PURE__*/_react["default"].createElement(Meta, null, /*#__PURE__*/_react["default"].createElement(Name, {
    inverse: inverse
  }, name), /*#__PURE__*/_react["default"].createElement(JobTitle, null, jobTitle))), /*#__PURE__*/_react["default"].createElement(Logo, {
    inverse: inverse
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: logo,
    alt: companyName,
    loading: "lazy"
  })))));
};

exports.Testimonial = Testimonial;